import { TelemetryManager } from "../opentelemetry/TelemetryManager";
export var useRenderTracing = function(operationName, attributes, options) {
    var span = TelemetryManager.get().startManagedSpan(operationName, attributes, options);
    return function() {
        TelemetryManager.get().endManagedSpan(span);
    };
};
